var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light-Outline/Logout"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logout"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1488 27.5H8.04125C4.98625 27.5 2.5 25.0138 2.5 21.9562V8.045C2.5 4.9875 4.98625 2.5 8.04125 2.5H14.135C17.1925 2.5 19.68 4.9875 19.68 8.045V9.21C19.68 9.7275 19.26 10.1475 18.7425 10.1475C18.225 10.1475 17.805 9.7275 17.805 9.21V8.045C17.805 6.02 16.1587 4.375 14.135 4.375H8.04125C6.02 4.375 4.375 6.02 4.375 8.045V21.9562C4.375 23.98 6.02 25.625 8.04125 25.625H14.1488C16.1638 25.625 17.805 23.985 17.805 21.97V20.7913C17.805 20.2738 18.225 19.8538 18.7425 19.8538C19.26 19.8538 19.68 20.2738 19.68 20.7913V21.97C19.68 25.02 17.1975 27.5 14.1488 27.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 14,
    width: 18,
    height: 2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2451 14.0625H28.1712V15.9375H11.2451V14.0625Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2339 15.9375H12.1826C11.6651 15.9375 11.2451 15.5175 11.2451 15C11.2451 14.4825 11.6651 14.0625 12.1826 14.0625H27.2339C27.7514 14.0625 28.1714 14.4825 28.1714 15C28.1714 15.5175 27.7514 15.9375 27.2339 15.9375Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 10,
    width: 7,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6367 10.4189H28.1709V19.5824H22.6367V10.4189Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5739 19.5824C23.3339 19.5824 23.0927 19.4911 22.9102 19.3061C22.5452 18.9386 22.5464 18.3461 22.9127 17.9811L25.9052 14.9999L22.9127 12.0199C22.5464 11.6549 22.5439 11.0624 22.9102 10.6949C23.2752 10.3274 23.8677 10.3274 24.2352 10.6924L27.8952 14.3361C28.0727 14.5111 28.1714 14.7511 28.1714 14.9999C28.1714 15.2486 28.0727 15.4886 27.8952 15.6636L24.2352 19.3086C24.0527 19.4911 23.8127 19.5824 23.5739 19.5824Z",
    fill: "currentColor"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.5a950c1fa409caa9faae5070308aebc4.svg";
export { ForwardRef as ReactComponent };